import { useStyletron } from 'baseui';
import { ProjectStatusEnum } from '@gtintel/platform-types';
import { ProjectStatusColourMap, hexToRGB, toTitleCase } from '@gtintel/platform-utils';
export const StatusDisplay = ({
  status
}) => {
  const [css] = useStyletron();
  const colour = ProjectStatusColourMap[status];
  return <div className={css({
    background: hexToRGB(colour, 0.1),
    borderRadius: '18px',
    color: colour,
    height: 'fit-content',
    padding: '4px 8px'
  })} data-testid="status-display">
      {toTitleCase(ProjectStatusEnum[status])}
    </div>;
};